export function useMapVariantsToState(isDisabled: boolean, checked?: boolean) {
  const checkboxSymbol =
    !isDisabled && checked
      ? 'rdicon-checkbox-checked'
      : 'rdicon-checkbox-unchecked'

  const checkboxColor = isDisabled
    ? 'colorTextNeutralDisabled'
    : checked
      ? 'colorActionFillBrandPrimaryEnabled'
      : 'colorTextNeutralDefault'

  const prefixIconColor = isDisabled
    ? 'colorTextNeutralDisabled'
    : 'colorTextNeutralDefault'

  const checkColor = isDisabled
    ? 'colorTextNeutralDisabled'
    : 'colorTextSuccessAlternative'

  return {
    checkboxSymbol,
    checkboxColor,
    prefixIconColor,
    checkColor,
  } as const
}
